// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-layout {
    display: flex;
    height: 100vh;
    overflow: hidden;
    background: #f1f5f9;
}

.main-content {
    flex: 1 1;
    margin-left: var(--sidebar-width, 230px);
    height: 100vh;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    overscroll-behavior-y: none;
    transition: margin-left 0.22s cubic-bezier(.4,0,.2,1);
}

/* Hide sidebar for mobile profile users ONLY on small screens (phones) */
@media (max-width: 768px) {
    body.mobile-profile .sidebar {
        display: none !important;
    }

    body.mobile-profile .main-content {
        margin-left: 0 !important;
    }
}

/* Barra Superior Uniforme */
.top-bar {
    background: white;
    padding: 11px 30px;
    border-bottom: 1px solid #e2e8f0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: sticky;
    top: 0;
    z-index: 100;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.top-bar-left {
    display: flex;
    align-items: center;
    gap: 16px;
}

.top-bar-left .btn-back {
    background: none;
    border: 1px solid #e2e8f0;
    color: #4a5568;
    padding: 8px 14px;
    border-radius: 8px;
    cursor: pointer;
    font-size: 0.9rem;
    font-weight: 500;
    display: flex;
    align-items: center;
    gap: 6px;
    transition: all 0.2s;
}

.top-bar-left .btn-back:hover {
    background: #f7fafc;
    border-color: #cbd5e0;
}

.top-bar-title {
    display: flex;
    flex-direction: column;
    gap: 2px;
}

.top-bar-title h1 {
    font-size: 1.4rem;
    font-weight: 700;
    color: #1a202c;
    margin: 0;
    display: flex;
    align-items: center;
    gap: 10px;
}

.top-bar-title p {
    font-size: 0.85rem;
    color: #718096;
    margin: 0;
}

.top-bar-actions {
    display: flex;
    gap: 12px;
    align-items: center;
    user-select: none;
}

/* Conteúdo da Página */
.page-content {
    flex: 1 1;
    padding: 30px;
    background: #f1f5f9;
}

/* Responsive */
@media (max-width: 768px) {
    .main-content {
        margin-left: 0;
    }

    .top-bar {
        padding: 12px 20px;
    }

    .top-bar-title h1 {
        font-size: 1.2rem;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/Layout.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,aAAa;IACb,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,SAAO;IACP,wCAAwC;IACxC,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,iCAAiC;IACjC,2BAA2B;IAC3B,qDAAqD;AACzD;;AAEA,yEAAyE;AACzE;IACI;QACI,wBAAwB;IAC5B;;IAEA;QACI,yBAAyB;IAC7B;AACJ;;AAEA,4BAA4B;AAC5B;IACI,iBAAiB;IACjB,kBAAkB;IAClB,gCAAgC;IAChC,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,gBAAgB;IAChB,MAAM;IACN,YAAY;IACZ,yCAAyC;AAC7C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,SAAS;IACT,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,SAAS;AACb;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA,uBAAuB;AACvB;IACI,SAAO;IACP,aAAa;IACb,mBAAmB;AACvB;;AAEA,eAAe;AACf;IACI;QACI,cAAc;IAClB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,iBAAiB;IACrB;AACJ","sourcesContent":[".app-layout {\r\n    display: flex;\r\n    height: 100vh;\r\n    overflow: hidden;\r\n    background: #f1f5f9;\r\n}\r\n\r\n.main-content {\r\n    flex: 1;\r\n    margin-left: var(--sidebar-width, 230px);\r\n    height: 100vh;\r\n    display: flex;\r\n    flex-direction: column;\r\n    overflow-y: auto;\r\n    -webkit-overflow-scrolling: touch;\r\n    overscroll-behavior-y: none;\r\n    transition: margin-left 0.22s cubic-bezier(.4,0,.2,1);\r\n}\r\n\r\n/* Hide sidebar for mobile profile users ONLY on small screens (phones) */\r\n@media (max-width: 768px) {\r\n    body.mobile-profile .sidebar {\r\n        display: none !important;\r\n    }\r\n\r\n    body.mobile-profile .main-content {\r\n        margin-left: 0 !important;\r\n    }\r\n}\r\n\r\n/* Barra Superior Uniforme */\r\n.top-bar {\r\n    background: white;\r\n    padding: 11px 30px;\r\n    border-bottom: 1px solid #e2e8f0;\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    position: sticky;\r\n    top: 0;\r\n    z-index: 100;\r\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);\r\n}\r\n\r\n.top-bar-left {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 16px;\r\n}\r\n\r\n.top-bar-left .btn-back {\r\n    background: none;\r\n    border: 1px solid #e2e8f0;\r\n    color: #4a5568;\r\n    padding: 8px 14px;\r\n    border-radius: 8px;\r\n    cursor: pointer;\r\n    font-size: 0.9rem;\r\n    font-weight: 500;\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 6px;\r\n    transition: all 0.2s;\r\n}\r\n\r\n.top-bar-left .btn-back:hover {\r\n    background: #f7fafc;\r\n    border-color: #cbd5e0;\r\n}\r\n\r\n.top-bar-title {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 2px;\r\n}\r\n\r\n.top-bar-title h1 {\r\n    font-size: 1.4rem;\r\n    font-weight: 700;\r\n    color: #1a202c;\r\n    margin: 0;\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 10px;\r\n}\r\n\r\n.top-bar-title p {\r\n    font-size: 0.85rem;\r\n    color: #718096;\r\n    margin: 0;\r\n}\r\n\r\n.top-bar-actions {\r\n    display: flex;\r\n    gap: 12px;\r\n    align-items: center;\r\n    user-select: none;\r\n}\r\n\r\n/* Conteúdo da Página */\r\n.page-content {\r\n    flex: 1;\r\n    padding: 30px;\r\n    background: #f1f5f9;\r\n}\r\n\r\n/* Responsive */\r\n@media (max-width: 768px) {\r\n    .main-content {\r\n        margin-left: 0;\r\n    }\r\n\r\n    .top-bar {\r\n        padding: 12px 20px;\r\n    }\r\n\r\n    .top-bar-title h1 {\r\n        font-size: 1.2rem;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
